import { Icon, Text } from '@betterment/samba-react';

import { SambaAutoLink } from '../../components/SambaAutoLink';
import { urlBuilder } from '../../utils/urlBuilder';

interface DownloadLinkProps {
  packageId: string;
  isSigned: boolean;
}

const DownloadLink: React.FC<DownloadLinkProps> = ({ packageId, isSigned }) => {
  return (
    <Text as="p">
      <SambaAutoLink to={urlBuilder.getSignablePackageDownload(packageId)}>
        Download {isSigned ? 'signed' : 'unsigned'} documents
        <Icon name="Download" size="small" aria-label="Download" css={{ ml: 'space.25', verticalAlign: 'bottom' }} />
      </SambaAutoLink>
    </Text>
  );
};

export default DownloadLink;
